export const FITNESS_REGISTER_DEADLINE = 'fitness-register-deadline';
